import Link from '../Link';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Styles from './Blog.module.scss';

const Categories = ({ style, className, ...props }) => (
  <div className={classNames(Styles.box, className)} style={style}>
    <h3 className={Styles.header}>{`Categories`}</h3>
    {props.showAll && (
      <Link className={Styles.storyLink} title='All' to='/blog'>
        {`All Categories`}
      </Link>
    )}
    <Link className={Styles.storyLink} title='Leaders' to='/blog/categories/leaders'>
      {`Leaders`}
    </Link>
    <Link className={Styles.storyLink} title='Digital' to='/blog/categories/digital'>
      {`Digital`}
    </Link>
    <Link className={Styles.storyLink} title='Storytelling' to='/blog/categories/storytelling'>
      {`Storytelling`}
    </Link>
    <Link
      className={Styles.storyLink}
      title='Hiring Resources'
      to='/blog/categories/hiring-resources'>
      {`Hiring Resources`}
    </Link>
    {/*<Link
      className={Styles.storyLink}
      title={`Hire Digital Updates`}
      to='/blog/categories/contentco-updates'>
      {`Hire Digital Updates`}
    </Link>*/}
  </div>
);

Categories.propTypes = {
  showAll: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default Categories;
